import { ApiError } from "./api";

type RequestOptions = {
  method?: "GET" | "POST";
  body?: unknown;
};

async function adminRequest<T>(path: string, options: RequestOptions = {}): Promise<T> {
  const { method = "GET", body } = options;

  const res = await fetch(`/api/admin${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const payload = (await res.json().catch(() => ({}))) as {
      code?: string;
      error?: string;
      message?: string;
    };
    throw new ApiError(
      res.status,
      payload.code ?? payload.error ?? "UNKNOWN_ERROR",
      payload.message ?? res.statusText,
    );
  }

  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}

export const adminApi = {
  get: <T>(path: string) => adminRequest<T>(path, { method: "GET" }),
  post: <T>(path: string, body?: unknown) => adminRequest<T>(path, { method: "POST", body }),
};
